import { Button, Form } from "antd";
import React, {useState} from "react";
import Select from "@components/ResponsiveSelect";

export const ProjectFilters = (props) => {

    const [status, setStatus] = useState([]);
    const [priority, setPriority] = useState([]);

    const formRef = React.useRef()

    function handleStatus(status) {
        if (status?.includes('All')) {
            formRef.current.setFieldsValue({
                status: ['All']
            })
        }
        setStatus(status);

    }

    function handlePriority(priority) {
        if (priority?.includes('All')) {
            formRef.current.setFieldsValue({
                priority: ['All']
            })
        }
        setPriority(priority);
    }

    const statusFilter = () => {
        return (
            <Select
                mode="single"
                allowClear
                value={status}
                style={{
                    width: '100%',
                }}
                getPopupContainer={trigger => trigger.parentNode}
                placeholder="Status"
                onChange={handleStatus}
                options={props.status_options}
                dropdownMatchSelectWidth={false}
            />
        )
    }

    const priorityFilter = () => {
        return (
            <Select
                mode="single"
                allowClear
                value={priority}
                style={{
                    width: '100%',
                }}
                dropdownMatchSelectWidth={false}
                getPopupContainer={trigger => trigger.parentNode}
                placeholder="Priority"
                onChange={handlePriority}
                options={props.priority_options}
            />
        )
    }

    function handleSubmit(e) {
        console.log('submit', e)
        props.handleFilter(e)
    }

    return <Form
        id="myForm"
        layout="inline"
        onFinish={handleSubmit}
        ref={formRef}
        style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
                        autoComplete="off">

        <Form.Item name={'status'} style={{ marginBottom: 0, width: 200 }}>
            {statusFilter()}
        </Form.Item>

        <Form.Item name={'priority'} style={{ marginBottom: 0, width: 200 }}>
            {priorityFilter()}
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit">Submit</Button>
        </Form.Item>
    </Form>

}
